import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AlertService } from '@kodit/core/services';
import { SupportAccessRequestService } from './support-access-request.service';

@Component({
  selector: 'kodit-create-support-access-request-dialog',
  templateUrl: './create-support-access-request-dialog.component.html',
})
export class CreateSupportAccessRequestDialogComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() submitted = new EventEmitter<void>();

  targetTenantKey = '';
  isLoading = false;

  constructor(
    private _service: SupportAccessRequestService,
    private _alertService: AlertService
  ) {}

  handleClose(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    this.targetTenantKey = '';
  }

  handleSubmit(): void {
    if (!this.targetTenantKey) {
      return;
    }
    this.isLoading = true;
    this._service.createRequest(this.targetTenantKey).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if (res?.succeeded) {
          this._alertService.addSuccessMsg('Zahtev za support pristup je poslat klijentu na odobrenje.');
          this.submitted.emit();
          this.handleClose();
        } else {
          this._alertService.addFailedMsg(res?.messages?.[0] ?? 'Greška pri slanju zahteva.');
        }
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }
}
